var path = 'src/app/patients/dialysis/dialysis.html';
var html = "<h1 class=page-header>Dialysis</h1> <div dialysis-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/dialysis/dialysis.html
 ** module id = 442
 ** module chunks = 0
 **/